import { render } from "./Dialog.vue?vue&type=template&id=4116a5e0&scoped=true&ts=true"
import script from "./Dialog.vue?vue&type=script&lang=ts"
export * from "./Dialog.vue?vue&type=script&lang=ts"

import "./Dialog.vue?vue&type=style&index=0&id=4116a5e0&scoped=true&lang=css"
import "./Dialog.vue?vue&type=style&index=1&id=4116a5e0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4116a5e0"]])

export default __exports__